import CardActionButton from "components/Cards/Card/Actions/Button"
import NewsCard from "components/News/NewsCard"

import { ComponentProps } from "."
import Actions from "./Actions"
import { Buttons, Row, Wrapper } from "./styled"

const Main = ({
  actionCheckboxes,
  clearAllListsButtonProps,
  clearListButtonProps,
  isAdmin,
  isEditor,
  listAllButtonProps,
  listButtonProps,
  loadMoreButtonProps,
  newsCards,
  siteConfigNews
}: ComponentProps) => (
  <Wrapper>
    <Buttons>
      <CardActionButton {...listAllButtonProps} />

      <CardActionButton {...clearAllListsButtonProps} />
    </Buttons>

    {siteConfigNews.map((item) => (
      <Row key={item.id}>
        {item.rows.map((row) => {
          const { onlyNewProps, onlyPresentProps, showFlaggedProps } =
            actionCheckboxes[row.serviceName]
          const newsCard = newsCards[row.serviceName]
          const clearListButton = clearListButtonProps[row.serviceName]
          const listButton = listButtonProps[row.serviceName]
          const loadMoreButton = loadMoreButtonProps[row.serviceName]

          return (
            <NewsCard
              {...newsCard}
              actions={
                <Actions
                  clearListButtonProps={clearListButton}
                  isAdmin={isAdmin}
                  isEditor={isEditor}
                  listButtonProps={listButton}
                  loadMoreButtonProps={loadMoreButton}
                  onlyNewProps={onlyNewProps}
                  onlyPresentProps={onlyPresentProps}
                  serviceName={row.serviceName}
                  showFlaggedProps={showFlaggedProps}
                />
              }
              key={row.serviceName}
              serviceName={row.serviceName}
            />
          )
        })}
      </Row>
    ))}
  </Wrapper>
)

Main.whyDidYouRender = true

export default Main
